import React from "react";

import ModalUploadDoc from "../../Modals/ModalUploadDoc";

const ProceedingCard = (props) => {
  return (
    <div
      className="d-flex border border-secondary p-4 rounded-3 mt-5"
      style={{ width: "60%" }}
    >
      <div className="d-flex flex-column text-start text-gray">
        <button className="btn-fill-grayblue mb-4 w-50">
          <label className="fw-normal me-1">Solicitud:</label>ID de vivienda
        </button>

        <label>
          Precio de la vivienda (Posibilidad de agregar un documento)
        </label>
        <input type="text" placeholder="$XXXXXX" className="mb-4 w-75" />

        <label className="fw-bold">
          Información proporcionada por el cliente
        </label>
        <label>
          <label className="fw-bold">Nombre:</label> {props.name}
        </label>
        <label>
          <label className="fw-bold">Correo electrónico:</label> {props.email}
        </label>
        <label>
          <label className="fw-bold">Teléfono:</label> {props.phone}
        </label>

        <label className="fw-bold mt-3">
          Información de inmueble en inventario
        </label>
        <label>
          <label className="fw-bold">Estado:</label> Querétaro
        </label>
        <label className="w-100">
          <label className="fw-bold">Ubicación:</label> Avenida Paseos del
          Marques #86. Col. Paseos del Marquez. II. Qro Condominio Andalucia
        </label>
        <label>
          <label className="fw-bold">Solución adquirida:</label> Solución CTC
        </label>
        <label>
          <label className="fw-bold">Asesor de compra asignado:</label> Martin
          Morales
        </label>
      </div>
      <div className="d-flex flex-column justify-content-end w-75">
        <button
          className="btn-fill-orange mb-2"
          data-bs-toggle="modal"
          data-bs-target="#ModalUploadDoc"
        >
          Integrar Expediente
        </button>
        <ModalUploadDoc />
        <button className="btn-fill-orange mb-2">
          Mandar a proceso de escrituración
        </button>
      </div>
    </div>
  );
};

export default ProceedingCard;
